// extracted by mini-css-extract-plugin
export default {"slide-practice-background":"styles_slide-practice-background__ss9RE","bg-blue":"styles_bg-blue__MTHpz","bg-yellow":"styles_bg-yellow__dbVnW","bg-red":"styles_bg-red__nQ4Ip"};